<template>
  <header>
    <div class="row">
      <div class="col" @click="$emit('toggle')">
        <h5>
          <slot></slot>
        </h5>
      </div>

      <div class="col-flex text-right header-toggle">
        <label class="actions" v-if="canEdit">
          <slot name="add"></slot>
        </label>
        
        <span class="actions" @click.stop="$emit('showSort')" v-if="showSort && canEdit">
          <i class="fa fa-sort" style="padding-right: .15em;"></i>
        </span>
        
        <span class="actions" @click.stop="create()" v-if="showAdd && canEdit">
          <i class="fa fa-plus-circle add"></i>
        </span>
        
        <span class="actions" @click.stop="$emit('showEdit')" v-if="showEdit && canEdit">
          <i class="fa fa-gear"></i>
        </span>
        
        <span class="actions" @click.stop="$emit('toggle')">
          <i v-if="showSection" class="fa fa-chevron-circle-down"></i>
          <i v-else class="fa fa-chevron-circle-up"></i>
        </span>
      </div>
    </div>
  </header>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "character-sheet-shared-header",
  props: ["showSection", "section", "showAdd", "showEdit", "showSort"],
  mounted() {
    // hide sections by default on mobile
    if (window.innerWidth < 576 && this.showSection) {
      this.$emit("toggle");
    }
  },
  computed: {
    ...mapGetters({ canEdit: "characters/canEdit" })
  },
  methods: {
    ...mapActions("characters", ["createItem"]),
    async create() {
      if (!this.showSection) {
        this.$emit("toggle");
      }
      let _vm = this;
      try {
        let item = await this.createItem({ section: this.section });
        _vm.$rpgv.toggleModal(_vm, `${_vm.section}-${item._id}`);
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../../assets/_global";

header {
  h5 {
    font-size: 1.25rem;
    font-weight: normal;
    line-height: 1em;
    margin: 0.25em;
    margin-left: 0.5em;
  }
}

.header-toggle {
  text-align: right;
}
i {
  line-height: 0.75rem !important;
}
.actions {
  font-size: 1.25rem;
  font-weight: bold;
  line-height: 1em;
  margin: 0.25em;
  margin-left: 0;
  display: inline-block;
  cursor: pointer;

  &:hover {
    color: rgba(255, 255, 255, 0.75);
  }
  .edit {
    &:hover {
      color: rgba(255, 255, 255, 0.5) !important;
    }
  }
  .add {
    &:hover {
      color: $green !important;
    }
  }
  a:not([href]):not([tabindex]) {
    color: rgba(255, 255, 255, 0.75);
    &:hover {
      color: $green;
    }
  }
}
</style>
